function addToCart($target, amount = 1) {
	if (typeof dataLayer != 'undefined') {
		dataLayer.push({ecommerce: null});
		dataLayer.push({
			event: "add_to_cart",
			ecommerce: {
				currency: "EUR",
				value: ($target.data('price') ?? 0) * amount,
				items: [{
					item_id: $target.data('productcode') ?? '',
					item_name: $target.data('title') ?? 0,
					price: $target.data('price') ?? 0,
					quantity: amount,
				}]
			}
		});
	}
};

$(document).on('click', '[data-ga-add-to-cart="button"]', (event) => {
	let $button = $(event.currentTarget);
	let amount = 1;
	let $wrapper = $button.closest('[data-ga-add-to-cart="wrapper"]');
	if($wrapper.length > 0) {
		let $input = $wrapper.find('[data-ga-add-to-cart="input"]');
		if($input.length > 0) {
			amount = $input.val();
		}
	}
	addToCart($button, amount);
	return true;
});